// extracted by mini-css-extract-plugin
module.exports = {"loader":"_93444fe79c--loader--njkFc"};